import Choices from 'choices.js';

document.querySelectorAll('select[id^="select"]:not([id^="select-page"])')
    .forEach(element => {
        new Choices(element, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false
        });
    });

document.querySelectorAll('select[id^="select-page"]')
    .forEach(element => {
        new Choices(element, {
            searchEnabled: true,
            searchPlaceholderValue: 'Bankensuche …',
            itemSelectText: '',
            shouldSort: true,
            noResultsText: 'Bank wurde nicht gefunden',
        });
    });